module.exports = __webpack_public_path__ + "static/media/NoAccesoBI.faedfe6d.png";